import { Record } from "../fable_modules/fable-library.3.7.17/Types.js";
import { obj_type, record_type, class_type, string_type } from "../fable_modules/fable-library.3.7.17/Reflection.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.1.2.6/./Mui.fs.js";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { printf, toText } from "../fable_modules/fable-library.3.7.17/String.js";
import { Interop_reactApi } from "../fable_modules/Feliz.1.68.0/./Interop.fs.js";
import { fromParts } from "../fable_modules/fable-library.3.7.17/Decimal.js";
import Decimal from "../fable_modules/fable-library.3.7.17/Decimal.js";
import { map, ofArray, singleton } from "../fable_modules/fable-library.3.7.17/List.js";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import { createElement } from "react";
import { Row } from "../../../Components/UtilComponents.fs.js";
import { TextSize, MarginTop } from "../../../Styles/Utils.fs.js";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";

export class SampleData extends Record {
    constructor(Type, PricePerSample) {
        super();
        this.Type = Type;
        this.PricePerSample = PricePerSample;
    }
}

export function SampleData$reflection() {
    return record_type("PriceListModal.SampleData", [], SampleData, () => [["Type", string_type], ["PricePerSample", class_type("System.Decimal")]]);
}

export class PropertyData extends Record {
    constructor(Type, StandardPrice) {
        super();
        this.Type = Type;
        this.StandardPrice = StandardPrice;
    }
}

export function PropertyData$reflection() {
    return record_type("PriceListModal.PropertyData", [], PropertyData, () => [["Type", string_type], ["StandardPrice", obj_type]]);
}

export class EPCData extends Record {
    constructor(Type, Price) {
        super();
        this.Type = Type;
        this.Price = Price;
    }
}

export function EPCData$reflection() {
    return record_type("PriceListModal.EPCData", [], EPCData, () => [["Type", string_type], ["Price", class_type("System.Decimal")]]);
}

export class ElectricalData extends Record {
    constructor(Type, Price) {
        super();
        this.Type = Type;
        this.Price = Price;
    }
}

export function ElectricalData$reflection() {
    return record_type("PriceListModal.ElectricalData", [], ElectricalData, () => [["Type", string_type], ["Price", class_type("System.Decimal")]]);
}

export function SampleTableRow(data) {
    let elements;
    return MuiHelpers_createElement(TableRow, [(elements = [MuiHelpers_createElement(TableCell, [["children", data.Type]]), MuiHelpers_createElement(TableCell, [["align", "right"], ["children", toText(printf("€ %.2f"))(data.PricePerSample)]])], ["children", Interop_reactApi.Children.toArray(Array.from(elements))])]);
}

export function PropertyTypeRow(data) {
    let elements, value;
    return MuiHelpers_createElement(TableRow, [(elements = [MuiHelpers_createElement(TableCell, [["children", data.Type]]), MuiHelpers_createElement(TableCell, [["align", "right"], ["children", (value = data.StandardPrice, (value instanceof Decimal) ? toText(printf("€ %.2f"))(value) : "op aanvraag")]])], ["children", Interop_reactApi.Children.toArray(Array.from(elements))])]);
}

export function PriceTableRow(priceTableRowInputProps) {
    let elements;
    const price = priceTableRowInputProps.price;
    return MuiHelpers_createElement(TableRow, [(elements = [MuiHelpers_createElement(TableCell, [["children", priceTableRowInputProps.itemType]]), MuiHelpers_createElement(TableCell, [["align", "right"], ["children", toText(printf("€ %.2f"))(price)]])], ["children", Interop_reactApi.Children.toArray(Array.from(elements))])]);
}

export function DisplayModal(displayModalInputProps) {
    let elements_16, children, elements_3, elements_1, elements, elements_2, elements_5, elements_4, elements_9, elements_7, elements_6, elements_8, elements_13, elements_11, elements_10, elements_12, children_1;
    const onClose = displayModalInputProps.onClose;
    const isOpen = displayModalInputProps.isOpen;
    const sampleData = singleton(new SampleData("Extra stalen", fromParts(3000, 0, 0, false, 2)));
    const propertyData = ofArray([new PropertyData("Ééngezinswoning", fromParts(49000, 0, 0, false, 2)), new PropertyData("Appartement", fromParts(43000, 0, 0, false, 2)), new PropertyData("Studio", fromParts(40000, 0, 0, false, 2)), new PropertyData("Garage", fromParts(21000, 0, 0, false, 2)), new PropertyData("Gemeenschappelijke delen", "op aanvraag"), new PropertyData("Bedrijf", "op aanvraag")]);
    const epcData = ofArray([new ElectricalData("Vrijstaande woning", fromParts(27000, 0, 0, false, 2)), new ElectricalData("Halfopen", fromParts(25000, 0, 0, false, 2)), new ElectricalData("Gesloten", fromParts(23000, 0, 0, false, 2)), new ElectricalData("Appartement", fromParts(21000, 0, 0, false, 2))]);
    const electricalData = singleton(new ElectricalData("Elektrische keuring", fromParts(19500, 0, 0, false, 2)));
    return MuiHelpers_createElement(Dialog, [["fullWidth", true], ["maxWidth", "md"], ["open", isOpen], ["onClose", (_arg_1, v) => {
        onClose(false);
    }], (elements_16 = [MuiHelpers_createElement(DialogTitle, [["children", "Prijzen inclusief 21% BTW"]]), (children = ofArray([MuiHelpers_createElement(Typography, [["style", {
        fontWeight: "bolder",
    }], ["variant", "subtitle1"], ["children", "Asbestattest"]]), MuiHelpers_createElement(Table, [(elements_3 = [MuiHelpers_createElement(TableHead, [(elements_1 = [MuiHelpers_createElement(TableRow, [(elements = [MuiHelpers_createElement(TableCell, [["style", {
        fontWeight: "bold",
    }], ["children", "Type"]]), MuiHelpers_createElement(TableCell, [["style", {
        fontWeight: "bold",
    }], ["align", "right"], ["children", "Prijs incl. BTW"]])], ["children", Interop_reactApi.Children.toArray(Array.from(elements))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_1))])]), MuiHelpers_createElement(TableBody, [(elements_2 = map((data) => createElement(PropertyTypeRow, data), propertyData), ["children", Interop_reactApi.Children.toArray(Array.from(elements_2))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_3))])]), createElement(Row, {
        classes: ofArray([MarginTop.S, TextSize.Xxs]),
        children: singleton("In de bedragen zitten 2 stalen en de OVAM-retributie begrepen."),
    }), MuiHelpers_createElement(Table, [["style", {
        marginTop: 16 + "px",
    }], (elements_5 = [MuiHelpers_createElement(TableBody, [(elements_4 = map((data_1) => createElement(SampleTableRow, data_1), sampleData), ["children", Interop_reactApi.Children.toArray(Array.from(elements_4))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_5))])]), MuiHelpers_createElement(Typography, [["style", {
        marginTop: 24 + "px",
        fontWeight: "bolder",
    }], ["variant", "subtitle1"], ["children", "EPC"]]), MuiHelpers_createElement(Table, [(elements_9 = [MuiHelpers_createElement(TableHead, [(elements_7 = [MuiHelpers_createElement(TableRow, [(elements_6 = [MuiHelpers_createElement(TableCell, [["style", {
        fontWeight: "bold",
    }], ["children", "Type"]]), MuiHelpers_createElement(TableCell, [["style", {
        fontWeight: "bold",
    }], ["align", "right"], ["children", "Prijs incl. BTW"]])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_6))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_7))])]), MuiHelpers_createElement(TableBody, [(elements_8 = map((data_2) => createElement(PriceTableRow, {
        itemType: data_2.Type,
        price: data_2.Price,
    }), epcData), ["children", Interop_reactApi.Children.toArray(Array.from(elements_8))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_9))])]), MuiHelpers_createElement(Typography, [["style", {
        marginTop: 24 + "px",
        fontWeight: "bolder",
    }], ["variant", "subtitle1"], ["children", "Elektrische keuring"]]), MuiHelpers_createElement(Table, [(elements_13 = [MuiHelpers_createElement(TableHead, [(elements_11 = [MuiHelpers_createElement(TableRow, [(elements_10 = [MuiHelpers_createElement(TableCell, [["style", {
        fontWeight: "bold",
    }], ["children", "Type"]]), MuiHelpers_createElement(TableCell, [["style", {
        fontWeight: "bold",
    }], ["align", "right"], ["children", "Prijs incl. BTW"]])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_10))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_11))])]), MuiHelpers_createElement(TableBody, [(elements_12 = map((data_3) => createElement(PriceTableRow, {
        itemType: data_3.Type,
        price: data_3.Price,
    }), electricalData), ["children", Interop_reactApi.Children.toArray(Array.from(elements_12))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_13))])])]), MuiHelpers_createElement(DialogContent, [["children", Interop_reactApi.Children.toArray(Array.from(children))]])), (children_1 = singleton(MuiHelpers_createElement(Button, [["onClick", (_arg_2) => {
        onClose(false);
    }], ["children", "Sluiten"]])), MuiHelpers_createElement(DialogActions, [["children", Interop_reactApi.Children.toArray(Array.from(children_1))]]))], ["children", Interop_reactApi.Children.toArray(Array.from(elements_16))])]);
}

export function PriceListModal(priceListModalInputProps) {
    const api = priceListModalInputProps.api;
    const onClose = priceListModalInputProps.onClose;
    const isOpen = priceListModalInputProps.isOpen;
    return createElement(DisplayModal, {
        isOpen: isOpen,
        onClose: onClose,
    });
}

